export default function isDateWithinFortnight(date: Date): boolean {
	const targetDay = new Date(date)
	const today = new Date()
	const daysAgo = Math.floor(
		(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()) -
			Date.UTC(
				targetDay.getFullYear(),
				targetDay.getMonth(),
				targetDay.getDate()
			)) /
			(1000 * 60 * 60 * 24)
	)

	return daysAgo < 14
}
